import type { TopAreaState } from '../models';
import type { ActionsType } from './actions';
import { ActionName } from './actions';

export const topAreaStoreReducer = (state: TopAreaState, action: ActionsType): TopAreaState => {
  const { type, data } = action;

  switch (type) {
    case ActionName.SET_BANNER_DATA: {
      const { BannerModel, DescriptionModel, NavigationModel } = data;

      const { BgImageSrc, BgVideoSrc, CategoryTitle, Headline, HeadlineTextColor, PageType } = BannerModel;
      const { SeoHeadline, Description } = DescriptionModel;

      const newState = {
        ...state,
        backgroundImageUrl: BgImageSrc,
        backgroundVideoUrl: BgVideoSrc,
        bannerHeadlineText: Headline,
        categoryTitle: CategoryTitle,
        contentDescription: Description,
        contentHeadline: SeoHeadline,
        pageType: PageType,
      };

      if (HeadlineTextColor && HeadlineTextColor !== '') {
        newState.bannerHeadLineColor = HeadlineTextColor;
      }
      if (NavigationModel?.NavigationItems) {
        newState.subPages = NavigationModel.NavigationItems;
      }

      return newState;
    }
    case ActionName.SET_BREADCRUMBS_DATA: {
      return {
        ...state,
        breadcrumbs: data,
      };
    }
    case ActionName.SET_IS_SUBNAV_NESTED: {
      if (state.isSubnavNested === data) {
        return state;
      }

      return {
        ...state,
        isSubnavNested: data,
      };
    }
    default:
      return state;
  }
};
